import { BodyText } from "@/components/ui";
import { useEffect } from "react";
import { type UseFormReturn, useFieldArray } from "react-hook-form";
import type { VisitClosureFormData, VisitClosureFormInput } from "../schemas";
import { EpisodeOfCareRow } from "./EpisodeOfCareRow";

interface BillingCodesStepProps {
  patientId: string;
  form: UseFormReturn<VisitClosureFormInput, unknown, VisitClosureFormData>;
}

export const BillingCodesStep = ({
  patientId,
  form,
}: BillingCodesStepProps) => {
  const { fields } = useFieldArray({
    control: form.control,
    name: "icd10.childEncounters",
  });

  // Trigger validation on mount to ensure Next button state is correct
  useEffect(() => {
    form.trigger("icd10");
  }, [form]);

  return (
    <>
      <div className="flex flex-row justify-between w-full mb-2">
        <BodyText size="sm" textColor="tertiary">
          Codes
        </BodyText>
        <BodyText size="sm" textColor="tertiary">
          Primary
        </BodyText>
      </div>
      {fields.map((field, index: number) => {
        return (
          <EpisodeOfCareRow
            key={field.id}
            patientId={patientId}
            form={form}
            index={index}
            {...field}
          />
        );
      })}
      <div className="flex flex-col gap-2">
        {form.formState.errors.icd10?.childEncounters?.message && (
          <BodyText size="sm" textColor="error">
            {form.formState.errors.icd10.childEncounters.message}
          </BodyText>
        )}
        {form.formState.errors.icd10?.primaryIcd10Code?.message && (
          <BodyText size="sm" textColor="error">
            {form.formState.errors.icd10.primaryIcd10Code.message}
          </BodyText>
        )}
        {fields.map((field, index) => {
          const childEncounterErrors =
            form.formState.errors.icd10?.childEncounters?.[index]?.icd10Codes;
          return childEncounterErrors?.message ? (
            <BodyText key={`error-${field.id}`} size="sm" textColor="error">
              {childEncounterErrors.message}
            </BodyText>
          ) : null;
        })}
      </div>
    </>
  );
};
